import { useSelector } from 'react-redux';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { Box, Flex, Skeleton } from '@chakra-ui/react';

import { getIndicatorTableDataStatus } from 'redux/PlanPageSlice';
import { STATUS } from 'projectConstants';

import MultiDimensionTableOpz from './MultiDimensionTableOpz';
import MultiDimensionTableOpzV2 from './MultiDimensionTableOpzV2';

import type { PlanPageRefetchRequest } from 'pages/PlanPageDetailsOPZ/PlanPageUIRevamp/planPageFetchHelpers';

interface Properties {
  refetchRequest: PlanPageRefetchRequest;
  isPercentage: any;
  flags?: any;
}

const TableSkeleton = () => (
  <Flex direction='column' pb='1'>
    {[...new Array(6)].map((_, index) => (
      <Flex key={index} p={2} justifyContent={'space-between'}>
        {[...new Array(4)].map((__, subIndex: number) => (
          <Box key={subIndex} flex={1} mr={2}>
            <Skeleton startColor='white' endColor='#CCD4E8' height='35px' width={'100%'} />
          </Box>
        ))}
      </Flex>
    ))}
  </Flex>
);

const IndicatorTable = ({ refetchRequest, isPercentage, flags }: Properties) => {
  const indicatorTableDataStatus = useSelector(getIndicatorTableDataStatus);

  if (indicatorTableDataStatus === STATUS.IDLE || indicatorTableDataStatus === STATUS.LOADING) {
    return <TableSkeleton />;
  }

  if (indicatorTableDataStatus === STATUS.FAILED) {
    return null;
  }

  return (
    <div style={{ display: 'flex', marginLeft: 8, marginTop: 8 }}>
      {!flags?.inputPanelOptimization ? (
        <MultiDimensionTableOpz
          refetchRequest={refetchRequest}
          isPercentage={isPercentage}
          isBuilderMode={false}
        />
      ) : (
        <MultiDimensionTableOpzV2
          refetchRequest={refetchRequest}
          isPercentage={isPercentage}
          isBuilderMode={false}
        />
      )}
    </div>
  );
};
export default withLDConsumer()(IndicatorTable);
